module.exports = __webpack_public_path__ + "static/media/portis.805b2921.svg";